export enum AutoExportFrequency {
  SPECIFIED_TIME = "specifiedTime",
  AFTER_UPDATE = "afterUpdate",
}
